import { API } from '~apis/axios/instance';
import {
  DateUnit,
  MonthlyCashFlowItem,
  CashFlowRequest as CashFlowRequest,
  MonthlyCashFlowSetting,
} from '~models/cashFlow';
import { ResponseBaseWithData } from '~types/response';

export type CashFlowStat = {
  highlight: boolean;
  name: string;
  description?: string;
  subName: string | null;
  amounts: Record<string, number>;
};

export interface GroupedCashFlow extends Omit<CashFlow, 'groupedCashFlowMap'> {
  groupId?: number;
  groupName?: string;
}

export interface CashFlow {
  itemMap: Record<string, MonthlyCashFlowItem[]>;
  baseDates: string[];
  unit: DateUnit;
  groupedCashFlowMap: {
    groupId: number;
    groupName: string;
    itemMap: Record<string, MonthlyCashFlowItem[]>;
  }[];
  hierarchy: string[];
  // 현금흐름 분석
  cashFlowStats: CashFlowStat[];
}
export const getCashFlow = ({
  companyId,
  startDate,
  endDate,
  rangeType,
  fxRuleType,
  cardProjectionType = 'BILLING',
}: CashFlowRequest) => {
  return API.get<ResponseBaseWithData<CashFlow>>(
    `/api/v3/companies/${companyId}/monthly-cash-flow`,
    {
      params: {
        startDate: startDate.format('YYYY-MM-DD'),
        endDate: endDate.format('YYYY-MM-DD'),
        rangeType,
        fxRuleType,
        cardProjectionType,
      },
    },
  );
};

export interface CashFlowValue {
  value: number;
  expression?: string;
  type: CashFlowValueType;
}

type CashFlowValueType = 'PERCENTAGE' | 'CURRENCY';
export type CashFlowSourceType = 'VALUE' | 'FUNCTION';

export const getCashFlowSettings = ({
  companyId,
  userId,
}: {
  companyId: string;
  userId: string;
}) => {
  return API.get<ResponseBaseWithData<MonthlyCashFlowSetting>>(
    `/api/v2/companies/${companyId}/users/${userId}/monthly-cash-flow/display-settings`,
  );
};

export const updateMonthlyCashFlowSettings = ({
  companyId,
  userId,
  data,
}: {
  companyId: string;
  userId: string;
  data: MonthlyCashFlowSetting;
}) => {
  return API.put<ResponseBaseWithData>(
    `/api/v2/companies/${companyId}/users/${userId}/monthly-cash-flow/display-settings`,
    {
      data: {
        ...data,
        companyId,
        userId,
      },
    },
  );
};

export const resetCashFlowSettings = ({
  companyId,
  userId,
}: {
  companyId: string;
  userId: string;
}) => {
  return API.put<ResponseBaseWithData>(
    `/api/v2/companies/${companyId}/users/${userId}/monthly-cash-flow/display-settings/reset`,
  );
};
